import { css } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";

const styles: string = css`
    .end-credits-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgb(27, 31, 43);
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        overflow: hidden;
        font-family: 'Arial', sans-serif;
    }
      
    .credits-content {
        width: 80%;
        height: 80%;
        overflow: hidden;
        position: relative;
        text-align: center;
    }
      
    .credits-text {
        position: absolute;
        width: 100%;
        transform: translateY(100%);
        white-space: pre-line;
        line-height: 1.8;
        font-size: 1.5rem;
        text-shadow: 0 0 5px rgba(255,255,255,0.3);
    }
      
    .new-game-btn {
        margin-top: 2rem;
        padding: 0.8rem 2rem;
        background: #4CAF50;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        font-size: 1.2rem;
        opacity: 0;
        transition: opacity 0.5s ease;
        pointer-events: none;
    }
      
    .new-game-btn.visible {
        opacity: 1;
        pointer-events: all;
    }
      
    .new-game-btn:hover {
        background: #45a049;
        transform: scale(1.05);
    }
      
    /* Section headers styling */
    .credits-text div {
        margin: 2rem 0;
    }
      
    .credits-text div:nth-child(odd) {
        font-weight: bold;
        font-size: 2rem;
        color: #4CAF50;
        text-shadow: 0 0 10px rgba(76, 175, 80, 0.5);
    }
`;

export class EndCreditsComponent extends HTMLElement {
    private readonly _gameEventService: GameEventService = new GameEventService();
    private creditsText!: HTMLDivElement;
    private newGameBtn!: HTMLButtonElement;
    private scrollAnimation!: number | null;
    private scrollComplete = false;
    private creditsContent: string = `
        <br>
        <br>
        <br>
        PRODUCED BY<br>
        <br>
        Continue? Entertainment<br>
        <img src="/assets/img/cutscenes/company_logo.png"><br>
        AKA E104-5<br>
        - Ali Bahadur<br>
        - Gino Zwaneveld<br>
        - Lena Velychko<br>
        - Meshano Fransman<br>
        - Rayan Lahoua<br>
        <br>
        GAME DIRECTION<br>
        <br>
        Creative Director: The Team<br>                  
        Game and Art Director: Lena Velychko,<br>
                            Ali Bahadur<br>
        Technical Director: Ali Bahadur<br>
        <br>
        DEVELOPMENT TEAM<br>
        <br>
        Lead Programmer: Lena Velychko<br>
        Programming Team:<br>
        - Rayan Lahoua - Gameplay Systems<br>
        - Ali Bahadur - AI Programming<br>
        - Lena Velychko - UI Programming<br>
        - Meshano Fransman - Tools Programming<br>
        - Gino Zwaneveld - Network Programming<br>
        <br>
        Game Design:<br>
        - Lead Designer: Lena Velychko<br>
        - Level Design: Ali Bahadur<br>
        - Systems Design: Gino Zwaneveld<br>
        - Quest Design: The Team<br>
        - Combat Design: Ali Bahadur<br>
        <br>
        Art Team:<br>
        - Lead Artist: Lena Velychko<br>
        - UI Artist: Lena Velychko,<br>
                    Ali Khan<br>
        - Concept Art: Ali Bahadur<br>
        - Character Art: Lena Velychko<br>
        - Animation: Rayan Lahoua,<br>
                    Lena Velychko<br>
        - VFX: Lena Velychko<br>
        <br>
        Audio Team:<br>
        - Sound Director: Lena Velychko<br>
        - Music Composition: Lena Velychko<br>
        - Sound Design: Lena Velychko<br>
        <br>
        Voice Actors:<br>
        - Ali Bahadur<br>
        - Meshano Fransman<br>
        - Lena Velychko
        <br>
        QUALITY ASSURANCE<br>
        <br>
        QA Lead: The Team<br>
        Testers:<br>
        Een paar allochtonen<br>
        <br>
        ADDITIONAL CONTRIBUTORS<br>
        <br>
        Writing/Narrative:<br>
        - Lead Writer: Ali Bahadur & Lena Velychko<br>
        - Dialogue: The Team<br>
        - Lore: The Team<br>
        <br>
        Production:<br>
        - Producer: Lena Velychko<br>
        - Assistant Producer: Gino Zwaneveld<br>
        <br>
        Languages:<br>
        - English<br>
        <br>
        Marketing:<br>
        - Marketing Director: The Team<br>
        - Community Manager: The Team<br>
        <br>
        VOICE CAST<br>
        <br>
        Pilot: Ali Bahadur<br>
        Assistent Pilot: Meshano Fransman<br>
        Stewardess: Lena Velychko<br>
        Airport Announcer 1: Ali Bahadur<br>
        Airport Announcer 2: Lena Velychko<br>
        News Reporter: Meshano Fransman<br>
        <br>
        SPECIAL THANKS TO<br>
        <br>
        Playtesters:<br>
        - Slotermeer<br>
        - Kraaiennest<br>
        - Zaandam<br>
        - Hoofddorp<br>
        - (welke dorpje Gino ook vandaan komt)<br>
        <br>
        Supporters:<br>
        - Jacqueline Hiemstra<br>
        - Daniel Doorn<br>
        - Sander van Kasteel<br>
        <br>
        Friends & Family:<br>
        - The Velychkos<br>
        - The Bahadurs<br>
        - The Lahouas<br>
        - The French Men<br>
        - The Swans in the Field<br>
        <br>
        Inspirations:<br>
        - That one brown guy's imagination.<br>
        <br>
        SOFTWARE AND TECHNOLOGIES USED<br>
        <br>
        Game Engine: LucasArts<br>
        Programming Languages: HTML, CSS, Typescript<br>
        <br>
        LICENSES AND ATTRIBUTIONS<br>
        <br>
        Music:<br>
        - Lofi music from youtube<br>
        - pond5.com<br>
        - YouTube copyright free music library<br>
        For Taxi room:<br>
        - Erasmo Carlos - É Preciso Dar Um Jeito, Meu Amigo<br>
        - Chico Buarque, MPB4 - Roda Viva<br>
        - Juca Chaves - Take Me Back To Piauí<br>
        - Gal Costa - Falsa Baiana<br>
        - Jorge Ben Jor - Os Alquimistas Estão Chegando os Alquimistas<br>
        - Sérgio Sampaio - Eu Quero é Botar Meu Bloco na Rua<br>
        - Quarteto em Cy, Chico Buarque - Pedro Pedreiro<br>
        - Chico Buarque - Cotidiano<br>
        - Novos Baianos - Na Cadência do Samba<br>
        - Jorge Ben Jor, Caetano Veloso - Ive Brussel<br>
        - Gal Costa - Barato Total<br>
        - Milton Nascimento - Travessia<br>
        - Tom Zé - Jimmy, Renda-se<br>
        - Gonzaguinha - Comportamento Geral<br>
        - Tim Maia - Azul da Cor do Mar<br>
        - Chico Buarque - Construção<br>
        <br>
        Sound Effects:<br>
        - Websites used: pond5.com & pixabay.com<br>
        - Library ambience from Youtube<br>
        <br>
        Animescenes used from:<br>
        - slap 1 - Cautious Hero<br>
        - slap 2 - Danshi Koukousei no Nichijou<br>
        - slap 3 - Love lab
        - seabeast scenes - Jujutsu Kaisen
        - eat 1 - The Walking Dead
        - eat 2 - Attack on Titan
        - eat 3 - Baki the Grappler
        <br>
        FINAL MESSAGE<br>
        <br>
        Thank you for playing The Lost City Of Azarath!<br>
        <br>
        Get ready for the next adventures Jayden Jones will hold!
        Follow us!     not in the creepy way please.<br>
        Don't copyright, we know our rights, we sue.<br>
        <br>
        2024/2025<br>
        Hogeschool van Amsterdam<br>
    `;

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
        this.initElements();
        this.startCredits(30); // Default duration of 30 seconds
    }

    private render(): void {
        if (!this.shadowRoot) return;

        this.shadowRoot.innerHTML = `
        <style>${styles}</style>
            <div class="end-credits-container">
            <div class="credits-content">
                <div class="credits-text">${this.creditsContent}</div>
            </div>
            <button class="new-game-btn">Exit Game</button>
            </div>
        `;
    }

    private initElements(): void {
        this.creditsText = this.shadowRoot!.querySelector(".credits-text") as HTMLDivElement;
        this.newGameBtn = this.shadowRoot!.querySelector(".new-game-btn") as HTMLButtonElement;
        this.scrollAnimation = null;
        this.scrollComplete = false;
        this.handleNewGameClick = this.handleNewGameClick.bind(this);
        this.newGameBtn.addEventListener("click", () => this.handleNewGameClick());
    }

    private startCredits(durationInSeconds: number): void {
        const startPosition: number = this.creditsText.parentElement!.offsetHeight;
        const endPosition: number = -this.creditsText.offsetHeight;
        const distance: number = startPosition - endPosition;
        const durationMs: number = durationInSeconds * 1000;
        const speed: number = distance / durationMs;

        let startTime: number | null = null;
        let currentPosition: number = startPosition;

        const scrollStep: (timestamp: number) => void = timestamp => {
            if (!startTime) {
                startTime = timestamp;
            }
            const elapsed: number = timestamp - startTime;

            if (elapsed < durationMs && currentPosition > endPosition) {
                currentPosition = startPosition - (speed * elapsed);
                this.creditsText.style.transform = `translateY(${currentPosition}px)`;
                this.scrollAnimation = requestAnimationFrame(scrollStep);
            }
            else {
                this.onScrollComplete();
            }
        };

        this.scrollAnimation = requestAnimationFrame(scrollStep);
    }

    private stopScrolling(): void {
        if (this.scrollAnimation) {
            cancelAnimationFrame(this.scrollAnimation);
            this.scrollAnimation = null;
        }
    }

    private onScrollComplete(): void {
        this.scrollComplete = true;
        this.newGameBtn.classList.add("visible");
        this._gameEventService.endCredits();
    }

    private handleNewGameClick(): void {
        if (this.scrollComplete) {
            this._gameEventService.newGame();
            this.remove();
        }
    }

    public disconnectedCallback(): void {
        this.newGameBtn.removeEventListener("click", () => this.handleNewGameClick());
        this.stopScrolling();
    }
}
